import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  props: {
  visible: { type: Boolean, default: true },
  showNav: { type: Boolean, default: true },
},
  setup(__props) {



return { __sfc: true, }
}

})